import { render, staticRenderFns } from "./SalesProductSidebar.vue?vue&type=template&id=8302c418&scoped=true&"
import script from "./SalesProductSidebar.vue?vue&type=script&lang=js&"
export * from "./SalesProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SalesProductSidebar.vue?vue&type=style&index=0&id=8302c418&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8302c418",
  null
  
)

export default component.exports